import { __decorate } from "tslib";
import Modal from "@/components/Modal.vue";
import ModalMixin from "@/mixins/modal-mixin";
import { Component, Mixins, Prop } from 'vue-property-decorator';
let AddSectionModal = class AddSectionModal extends Mixins(ModalMixin) {
    id;
    action;
    initialData;
    data = {
        fields: [],
        label: '',
        location: [],
        name: '',
    };
    errors = {};
    get locations() {
        return [
            { text: 'Exam window', value: 'exam' },
            { text: 'Profile modal', value: 'profile' },
            { text: 'Health card', value: 'healthcard' },
        ];
    }
    shown() {
        if (!this.initialData)
            return;
        this.data = JSON.parse(JSON.stringify(this.initialData));
    }
    hidden() {
        this.data = {
            fields: [],
            label: '',
            location: [],
            name: '',
        };
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    use() {
        this.$root.$emit('bv::hide::modal', this.id);
        this.action(this.data);
    }
};
__decorate([
    Prop({ type: String, required: true })
], AddSectionModal.prototype, "id", void 0);
__decorate([
    Prop({ type: Function, required: true })
], AddSectionModal.prototype, "action", void 0);
__decorate([
    Prop({ type: Object })
], AddSectionModal.prototype, "initialData", void 0);
AddSectionModal = __decorate([
    Component({
        name: 'add-section-modal',
        components: {
            Modal,
        },
    })
], AddSectionModal);
export default AddSectionModal;
